import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const ApplicationMain = () => {
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customerid');
  const [customerInfo, setCustomerInfo] = useState(null);

  useEffect(() => {
    if (customerId) {
      // Store customer ID for future use
      setCustomerInfo({ customerId });
    }
  }, [customerId]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-white flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-white rounded-3xl shadow-2xl p-12 text-center">
        <div className="w-24 h-24 bg-gradient-to-r from-purple-600 to-purple-800 rounded-full flex items-center justify-center mx-auto mb-8">
          <CheckCircle className="h-16 w-16 text-white" />
        </div>
        
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Thank You for Your Submission!
        </h1>
        
        <p className="text-xl text-gray-600 mb-6">
          Your trademark registration request has been received successfully.
        </p>
        
        {customerId && (
          <div className="bg-purple-50 rounded-xl p-6 mb-8">
            <p className="text-sm text-gray-600 mb-2">Your Reference ID:</p>
            <p className="text-2xl font-bold text-purple-700">{customerId}</p>
          </div>
        )}
        
        <div className="space-y-4 text-left">
          <div className="flex items-start space-x-3">
            <CheckCircle className="h-6 w-6 text-purple-600 flex-shrink-0 mt-0.5" />
            <p className="text-gray-700">
              Our trademark experts will review your information within 24 hours
            </p>
          </div>
          <div className="flex items-start space-x-3">
            <CheckCircle className="h-6 w-6 text-purple-600 flex-shrink-0 mt-0.5" />
            <p className="text-gray-700">
              You'll receive a confirmation email with next steps shortly
            </p>
          </div>
          <div className="flex items-start space-x-3">
            <CheckCircle className="h-6 w-6 text-purple-600 flex-shrink-0 mt-0.5" />
            <p className="text-gray-700">
              A dedicated case manager will be assigned to your application
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-gray-600">
            Questions? Contact us at{' '}
            <a href="mailto:info@trademarkcredentials.com" className="text-purple-700 font-semibold hover:text-purple-800">
              info@trademarkcredentials.com
            </a>
            {' '}or{' '}
            <a href="tel:+15551234567" className="text-purple-700 font-semibold hover:text-purple-800">
              +1 (877) 410-0136
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ApplicationMain;
